import React from 'react'
import { menuItems, projectMenuItems, companyMenuItems, IIPRLMenuItems } from './menuJson'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { getCompanySession, getProjectSession, modulesAllowedInProject } from '../../../../../app/component/helper'
import { useAuth } from '../../../../../app/modules/auth'

interface MenuItem {
    to?: string
    title: string
    fontIcon?: string
    icon?: string
    hasBullet?: boolean
    module?: string
    subMenuItems?: MenuItem[]
}

interface SidebarProps {
    items: MenuItem[]
    moudles: string[]
}

const Sidebar: React.FC<SidebarProps> = ({ items, moudles }) => {
    const renderMenu = (items: MenuItem[]): React.ReactNode => {
        return items.map((menuItem, index) => (
            moudles.includes(menuItem?.module || '') && (
                menuItem.subMenuItems ? (
                    <SidebarMenuItemWithSub
                        key={index}
                        to={menuItem.to ?? ''}
                        title={menuItem.title}
                        fontIcon={menuItem.fontIcon}
                        icon={menuItem.icon}
                    >
                        {renderMenu(menuItem.subMenuItems)}
                    </SidebarMenuItemWithSub>
                ) : (
                    <SidebarMenuItem
                        key={index}
                        to={menuItem.to ?? ''}
                        icon={menuItem.icon}
                        title={menuItem.title}
                        fontIcon={menuItem.fontIcon}
                        hasBullet={menuItem.hasBullet}
                    />
                )
            )
        ));
    };

    return <>{renderMenu(items)}</>;
};

export const SidebarMenuItems: React.FC = () => {
    const { currentUser } = useAuth();
    const user = currentUser;

    if (user) {

        let StaticAuth = ['auth', 'dashboard'];

        if (user?.accesses?.role === 'super-admin') {
            StaticAuth = ['roles', 'auth', 'dashboard'];
        }

        const roleModules = Array.isArray(user?.accesses?.modules) ? user.accesses.modules : [];

        if (isCompanyDashboard()) {
            const companyDashboard = getCompanySession();
            return (
                <Sidebar
                    items={companyDashboard?.id === 14 ? IIPRLMenuItems : companyMenuItems}
                    moudles={[...roleModules, ...StaticAuth]}
                />
            );
        } else if (isProjectDashboard()) {
            const projectModules = getProjectSession()?.project_modules || [];
            return (
                // <Sidebar
                //     items={projectMenuItems}
                //     moudles={[...modulesAllowedInProject(roleModules, projectModules), 'auth', 'dashboard', 'project_settings']}
                // />
                <Sidebar items={projectMenuItems} moudles={[...roleModules, ...StaticAuth]} />
            );
        } else {
            return <Sidebar items={menuItems} moudles={[...roleModules, ...StaticAuth]} />;
        }
    }

    return null;
};

// Utility functions

export const isCompanyUser = (company_id: string | number | null | undefined): boolean => {
    return !!company_id;
};

export const isCompanyDashboard = (): boolean => {
    return !!getCompanySession();
};

export const isProjectUser = (project_id: string | number | null | undefined): boolean => {
    return !!project_id;
};

export const isProjectDashboard = (): boolean => {
    return !!getProjectSession();
};
